/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceNotFoundRouteImport } from './routes/workspace-not-found'
import { Route as EorIndexRouteImport } from './routes/eor/index'
import { Route as SignTokenRouteImport } from './routes/sign/$token'
import { Route as ReviewTokenRouteImport } from './routes/review/$token'
import { Route as EorWorkspaceRouteImport } from './routes/eor/workspace'
import { Route as EorSelectWorkspaceRouteImport } from './routes/eor/select-workspace'
import { Route as EorNoWorkspaceRouteImport } from './routes/eor/no-workspace'
import { Route as EorFindRouteImport } from './routes/eor/find'
import { Route as EorCheckInboxRouteImport } from './routes/eor/check-inbox'

const WorkspaceNotFoundRoute = WorkspaceNotFoundRouteImport.update({
  id: '/workspace-not-found',
  path: '/workspace-not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const EorIndexRoute = EorIndexRouteImport.update({
  id: '/eor/',
  path: '/eor/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignTokenRoute = SignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewTokenRoute = ReviewTokenRouteImport.update({
  id: '/review/$token',
  path: '/review/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const EorWorkspaceRoute = EorWorkspaceRouteImport.update({
  id: '/eor/workspace',
  path: '/eor/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const EorSelectWorkspaceRoute = EorSelectWorkspaceRouteImport.update({
  id: '/eor/select-workspace',
  path: '/eor/select-workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const EorNoWorkspaceRoute = EorNoWorkspaceRouteImport.update({
  id: '/eor/no-workspace',
  path: '/eor/no-workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const EorFindRoute = EorFindRouteImport.update({
  id: '/eor/find',
  path: '/eor/find',
  getParentRoute: () => rootRouteImport,
} as any)
const EorCheckInboxRoute = EorCheckInboxRouteImport.update({
  id: '/eor/check-inbox',
  path: '/eor/check-inbox',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/workspace-not-found': typeof WorkspaceNotFoundRoute
  '/eor/check-inbox': typeof EorCheckInboxRoute
  '/eor/find': typeof EorFindRoute
  '/eor/no-workspace': typeof EorNoWorkspaceRoute
  '/eor/select-workspace': typeof EorSelectWorkspaceRoute
  '/eor/workspace': typeof EorWorkspaceRoute
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/eor/': typeof EorIndexRoute
}
export interface FileRoutesByTo {
  '/workspace-not-found': typeof WorkspaceNotFoundRoute
  '/eor/check-inbox': typeof EorCheckInboxRoute
  '/eor/find': typeof EorFindRoute
  '/eor/no-workspace': typeof EorNoWorkspaceRoute
  '/eor/select-workspace': typeof EorSelectWorkspaceRoute
  '/eor/workspace': typeof EorWorkspaceRoute
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/eor': typeof EorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/workspace-not-found': typeof WorkspaceNotFoundRoute
  '/eor/check-inbox': typeof EorCheckInboxRoute
  '/eor/find': typeof EorFindRoute
  '/eor/no-workspace': typeof EorNoWorkspaceRoute
  '/eor/select-workspace': typeof EorSelectWorkspaceRoute
  '/eor/workspace': typeof EorWorkspaceRoute
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/eor/': typeof EorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/workspace-not-found'
    | '/eor/check-inbox'
    | '/eor/find'
    | '/eor/no-workspace'
    | '/eor/select-workspace'
    | '/eor/workspace'
    | '/review/$token'
    | '/sign/$token'
    | '/eor/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/workspace-not-found'
    | '/eor/check-inbox'
    | '/eor/find'
    | '/eor/no-workspace'
    | '/eor/select-workspace'
    | '/eor/workspace'
    | '/review/$token'
    | '/sign/$token'
    | '/eor'
  id:
    | '__root__'
    | '/workspace-not-found'
    | '/eor/check-inbox'
    | '/eor/find'
    | '/eor/no-workspace'
    | '/eor/select-workspace'
    | '/eor/workspace'
    | '/review/$token'
    | '/sign/$token'
    | '/eor/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WorkspaceNotFoundRoute: typeof WorkspaceNotFoundRoute
  EorCheckInboxRoute: typeof EorCheckInboxRoute
  EorFindRoute: typeof EorFindRoute
  EorNoWorkspaceRoute: typeof EorNoWorkspaceRoute
  EorSelectWorkspaceRoute: typeof EorSelectWorkspaceRoute
  EorWorkspaceRoute: typeof EorWorkspaceRoute
  ReviewTokenRoute: typeof ReviewTokenRoute
  SignTokenRoute: typeof SignTokenRoute
  EorIndexRoute: typeof EorIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace-not-found': {
      id: '/workspace-not-found'
      path: '/workspace-not-found'
      fullPath: '/workspace-not-found'
      preLoaderRoute: typeof WorkspaceNotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/': {
      id: '/eor/'
      path: '/eor'
      fullPath: '/eor/'
      preLoaderRoute: typeof EorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign/$token': {
      id: '/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof SignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$token': {
      id: '/review/$token'
      path: '/review/$token'
      fullPath: '/review/$token'
      preLoaderRoute: typeof ReviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/workspace': {
      id: '/eor/workspace'
      path: '/eor/workspace'
      fullPath: '/eor/workspace'
      preLoaderRoute: typeof EorWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/select-workspace': {
      id: '/eor/select-workspace'
      path: '/eor/select-workspace'
      fullPath: '/eor/select-workspace'
      preLoaderRoute: typeof EorSelectWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/no-workspace': {
      id: '/eor/no-workspace'
      path: '/eor/no-workspace'
      fullPath: '/eor/no-workspace'
      preLoaderRoute: typeof EorNoWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/find': {
      id: '/eor/find'
      path: '/eor/find'
      fullPath: '/eor/find'
      preLoaderRoute: typeof EorFindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eor/check-inbox': {
      id: '/eor/check-inbox'
      path: '/eor/check-inbox'
      fullPath: '/eor/check-inbox'
      preLoaderRoute: typeof EorCheckInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  WorkspaceNotFoundRoute: WorkspaceNotFoundRoute,
  EorCheckInboxRoute: EorCheckInboxRoute,
  EorFindRoute: EorFindRoute,
  EorNoWorkspaceRoute: EorNoWorkspaceRoute,
  EorSelectWorkspaceRoute: EorSelectWorkspaceRoute,
  EorWorkspaceRoute: EorWorkspaceRoute,
  ReviewTokenRoute: ReviewTokenRoute,
  SignTokenRoute: SignTokenRoute,
  EorIndexRoute: EorIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
